import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconPaymentDinersclub = forwardRef((props, ref) => _jsxs(Container, {
  "data-testid": "IconPaymentDinersclub",
  viewBox: "0 0 22 16",
  ref: ref,
  ...props,
  children: [_jsx("path", {
    fill: "#0068AC",
    fillRule: "evenodd",
    d: "M1.91 0A1.9 1.9 0 0 0 0 1.88v12.24A1.9 1.9 0 0 0 1.91 16H20.1a1.9 1.9 0 0 0 1.9-1.88V1.88A1.9 1.9 0 0 0 20.09 0z",
    clipRule: "evenodd"
  }), _jsx("path", {
    fill: "#fff",
    d: "M9.57 6.18v3.64A1.9 1.9 0 0 0 11 8c0-.87-.61-1.6-1.43-1.82"
  }), _jsx("path", {
    fill: "#fff",
    d: "M12.91 4.24H9.1A3.8 3.8 0 0 0 5.26 8a3.8 3.8 0 0 0 3.83 3.77h3.82A3.8 3.8 0 0 0 16.74 8a3.8 3.8 0 0 0-3.83-3.76M9.1 10.82c-1.6 0-2.88-1.26-2.88-2.82S7.5 5.18 9.09 5.18 11.96 6.44 11.96 8s-1.29 2.82-2.87 2.82"
  }), _jsx("path", {
    fill: "#fff",
    d: "M8.6 6.18c-.8.22-1.42.95-1.42 1.82s.62 1.6 1.44 1.82z"
  })]
}));